import { ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import {
  getDaysSinceStartSale,
  getOperationCode,
  getProductSourceKey,
  getProductTitle,
  getSaleStartTime,
  getSubUniverseNameExcludingAllProducts,
  getUniverseNameExcludingAllProducts
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

const mapStateToMPEvent = (eventName, state) => {
  return ({
    'Days Since Sale Start': getDaysSinceStartSale(state),
    'Event Name': eventName,
    'Interaction Type': 'Click',
    'Operation Code': getOperationCode(state),
    'Page Name': 'Product Page',
    'Product': getProductTitle(state),
    'Product ID': getProductSourceKey(state),
    'Sale Start Time': getSaleStartTime(state),
    'Under Universe': getSubUniverseNameExcludingAllProducts(state),
    'Universe': getUniverseNameExcludingAllProducts(state)
  })
}

const clickPersonnalizeYourTripEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(Actions.product.SEE_OFFERS_BUTTON_CLICK),
  tap(() => {
    const eventName = 'Click Personnalize Your Trip'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default clickPersonnalizeYourTripEpic
